import React, { Component } from "react";
import Loader from 'react-loader-spinner';
import Button from '@material-ui/core/Button';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import DateRangePicker, { DateRange } from '@material-ui/lab/DateRangePicker';
import DatePicker from '@material-ui/lab/DatePicker';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import Box from '@material-ui/core/Box';
import DTable from '../dtable.component';
import swal from 'sweetalert';

import AuthService from '../../services/auth/auth.service';
import CorporateService from '../../services/crm/corporatereports.service';

import UserContext from "../../contexts/UserContext";
import NoPermission from "../extras/nopermission.component";
export default class CorporateCustomers extends Component {
    static contextType = UserContext;
    constructor(props){
        super(props);

        this.state = {
            createCompanyName: "",
            createLandline: "",
            createAddress: "",
            createEmail: "",
            createCouponCode: "",
            user: [],
            data: [],
            show: false,
            columnsheadings: [
                { title: "ID" },
                { title: "Company Name" },
                { title: "Corporate Discount Code" },
                { title: "Corporate Email" },
                { title: "Contact Person" },
                { title: "Mobile" },
                { title: "All Time from Other Accounts" },  
                { title: "All Time" },  
                { title: "Past 30 Days" },
                { title: "Past 12 months" },
                { title: "Last Order" },
                { title: "Account Creation Date" },
                { title: "Corporate Profile" },
            ],
            showloader: false,
            allowed: true
        };
    }

    componentDidMount() {
        AuthService.checklogin().then(user => {
            this.setState({
                user: user
            });

            console.log({ user });

            AuthService.getUserPermisions(user)
            .then(response => {
                var userpermissions = response.data;
                console.log({userpermissions});
                    if(userpermissions.includes('corporate') || userpermissions.includes('all')) {
                    console.log('You are allowed!');
                    this.setState({
                        allowed: true
                    });
                    this.getAll();
                } else {
                    console.log('You are not allowed!');
                    this.setState({
                        allowed: false
                    });
                }
            })
        }).catch(error => {
            window.location.href = '/login';
        });
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        // console.log('handle change');
    }

    createCorporateCustomer = (e) => {
        e.preventDefault();
        CorporateService.createCorporateCustomer(this.state.createCompanyName, this.state.createLandline, this.state.createAddress, this.state.createEmail, this.state.createCouponCode)
        .then(response => {
            console.log({response});
            this.setState({
                createCompanyName: "",
                createLandline: "",
                createAddress: "",
                createEmail: "",
                createCouponCode: "",
            });

            document.getElementById('close-modal').click();
            swal('Customer Created!', 'The cuustomer has been created and the coupon has been created as well', 'info');
            this.getAll();
        })
        .catch(error => {
            console.log({error});
        });
        console.log('Submitted');
    }

    getAll = () => {
        this.setState({
            data: [],
            show: false,
            showloader: true
        });
        CorporateService.getAll()
        .then(response => {
            console.log({response});
            if(response.data.length>0) {
                this.setState({
                    data: response.data,
                    show: true,
                    showloader: false
                });
            }
        })
        .catch(error => {
            console.log({error});
            this.setState({
                data: [],
                show: false,
                showloader: false
            });
        });
    }

    render() {

        if(this.state.allowed==false) {
            return (
                <NoPermission />
            );
        }
        
        return(
            <>
            <div className="row">
                <div className='col-6'>
                    <h3><AccountBoxIcon fontSize="large" /> Corporate Summary</h3>
                </div>
                <div className='col-6'>
                    <button className="btn btn-success" data-toggle="modal" data-target="#createCorporateCustomerModal" style={{float:"right"}}>Create Corporate Customer</button>
                </div>
                <div className="modal fade" id="createCorporateCustomerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add New Corporate Customer</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form id="creatCorporateCustomerForm" onSubmit={this.createCorporateCustomer.bind(this)}>
                        <div className="modal-body">
                            <div className="form-group">
                                <label for="createCompanyName">Company Name:</label>
                                <input type="text" className="form-control" value={this.state.createCompanyName} id="createCompanyName" name="createCompanyName" placeholder="Enter Company Name" required="required" onChange={this.handleChange.bind(this)} />
                            </div>

                            <div className="form-group">
                                <label for="createLandLine">Landline</label>
                                <input type="text" className="form-control" value={this.state.createLandline} id="createLandline" name="createLandline" placeholder="Enter Landline Number" required="required" onChange={this.handleChange.bind(this)} />
                            </div>

                            <div className="form-group">
                                <label for="createAddress">Address:</label>
                                <input type="text" className="form-control" value={this.state.createAddress} id="createAddress" name="createAddress" placeholder="Enter Address" required="required" onChange={this.handleChange.bind(this)} />
                            </div>

                            <div className="form-group">
                                <label for="createEmail">Email:</label>
                                <input type="text" className="form-control" value={this.state.createEmail} id="createEmail" name="createEmail" placeholder="Enter Email" required="required" onChange={this.handleChange.bind(this)} />
                            </div>

                            <div className="form-group">
                                <label for="createCouponCode">Discount Coupon Code:</label>
                                <input type="text" className="form-control" value={this.state.createCouponCode} id="createCouponCode" name="createCouponCode" placeholder="Enter Coupon Code" required="required" onChange={this.handleChange.bind(this)} />
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" id="close-modal" data-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn-success">Create Corporate Customer</button>
                        </div>
                        </form>
                        </div>
                    </div>
                </div>
                <div className='col-12'>
                    <hr />
                </div>
            </div>
            <div className="row">
                    <div className="col">
                        {(this.state.show == true) &&
                            <DTable data={this.state.data} columns={this.state.columnsheadings} sortTarget={[7, 8, 9]} />
                        }

                        {(this.state.showloader == true) &&
                            <Loader className='loader-center'
                                type="Grid"
                                color="#00BFFF"
                                height={100}
                                width={100}
                            />
                        }
                    </div>
                </div>

                <div className="modal" tabindex="-1" role="dialog" id="corporate-gen-password-modal">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Generate / Update Password</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form className="corporate-gen-password-form">
                        <div className="modal-body">
                            <input type="hidden" value="0" id="corporate-gen-password-user-id" />
                            <div className="form-group">
                                <label for="corporate-gen-password-password">New Password</label>
                                <input type="text" className="form-control" id="corporate-gen-password-password" aria-describedby="passwordHelp" placeholder="Enter password" required="required" />
                                <small id="passwordHelp" className="form-text text-muted">Please enter the password and also save the password on your side as well as the password will be encrypted and can only be changed not seen later.</small>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success">Save</button>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                        </form>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}